import { ProfileIcon, UserIcon } from '@ygtechnologies/bygr-frontend-component-library';
import React, { useState } from 'react';
import theme from './LinkProjectModal.module.scss';
import { memberSort } from './LinkProjectSelectUsers';
import { LinkProjectData } from './LinkProjectModal';
import { ButtonBar, Button } from '@ygtechnologies/rubus-ui';

interface LinkProjectSummaryProps {
    projectData: LinkProjectData;
    onSave(): Promise<void>;
    onCancel(): void;
    onBack(): void;
}

const LinkProjectSummary: React.FC<LinkProjectSummaryProps> = ({ projectData, onSave, onCancel, onBack }) => {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const handleSave = async () => {
        setIsSaving(true);
        await onSave();
        setIsSaving(false);
    };

    return (
        <div>
            <h4>Responsible profile</h4>
            <div className={theme.selectButton}>
                <ProfileIcon profileIconUrl="" sizeInPx={36} className={theme.companyImg} />
                {projectData.sellerProfileName}
            </div>

            <h4>Members</h4>
            <ul className={theme.list}>
                {projectData.members.sort(memberSort).map((member) => (
                    <li key={member.userId}>
                        <div className={theme.participantWrapper}>
                            <ProfileIcon profileIconUrl="" sizeInPx={36} className={theme.companyIcon} />
                            <div className={theme.icons}>
                                <UserIcon avatarThumbnailUrl="" sizeInPx={24} className={theme.employeeIcon} />
                            </div>
                            <div className={theme.userInfo}>
                                <div>{member.userName}</div>
                                <div className={theme.companyRole}>{member.email}</div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>

            <ButtonBar>
                <Button onClick={onCancel} variant="tertiary">
                    Cancel
                </Button>
                <Button onClick={onBack} variant="tertiary">
                    Back
                </Button>
                <Button onClick={handleSave} loading={isSaving} variant="primary">
                    Create
                </Button>
            </ButtonBar>
        </div>
    );
};

export default LinkProjectSummary;
